import HeyGenStreaming, { StreamingEvents } from '@heygen/streaming-avatar';
import config from '@src/js/config';
import { AvatarManager } from "@src/js/avatar-managers/AvatarManager";
export var AvatarEvents;
(function (AvatarEvents) {
    AvatarEvents["AVATAR_LOADED"] = "avatarLoaded";
})(AvatarEvents || (AvatarEvents = {}));
export class HeygenAvatarManager extends AvatarManager {
    constructor(config, videoElement) {
        super();
        this.avatar = null;
        this.sessionId = null;
        this.avatarLoading = true;
        this.token = null;
        this._isSpeaking = false;
        this.avatarConfig = config;
        this.videoElement = videoElement;
    }
    static async init(config, videoElement) {
        const controller = new HeygenAvatarManager(config, videoElement);
        await controller.initialize();
        return controller;
    }
    async initialize() {
        try {
            await this.fetchToken();
            if (!this.token)
                throw new Error('Token is not available');
            this.avatar = new HeyGenStreaming({ token: this.token });
            this.avatar.on(StreamingEvents.STREAM_READY, ({ detail }) => {
                this.videoElement.srcObject = detail;
            });
            this.avatar.on('avatarLoaded', () => {
                console.log('✅ Avatar loaded');
                this.avatarLoading = false;
                this.emit(AvatarEvents.AVATAR_LOADED, undefined);
            });
            // Listen for speaking events to properly manage speaking state
            this.avatar.on(StreamingEvents.AVATAR_START_TALKING, () => {
                console.log('🗣️ Avatar started talking');
                this._isSpeaking = true;
                this.emit('avatarStartSpeaking', '');
            });
            this.avatar.on(StreamingEvents.AVATAR_STOP_TALKING, () => {
                console.log('🔇 Avatar stopped talking');
                this._isSpeaking = false;
                this.emit('avatarStopSpeaking');
                // Trigger processing of next item in queue when avatar stops speaking
                this._maybeSpeakNext();
            });
            const session = await this.avatar.createStartAvatar(this.avatarConfig);
            this.sessionId = session.session_id;
        }
        catch (err) {
            console.error('Error starting avatar:', err);
        }
    }
    async fetchToken() {
        const res = await fetch(config.API_URL + 'chat/token', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });
        const data = await res.json();
        if (!data?.data?.token)
            throw new Error('Failed to fetch streaming token.');
        this.token = data.data.token;
    }
    async speak(text) {
        try {
            await this.avatar?.speak({
                text: text,
                task_type: 'repeat',
            });
        }
        catch (err) {
            console.error('Error during speak:', err);
            this._isSpeaking = false; // Reset speaking state on error
            throw err;
        }
    }
    isSpeaking() {
        return this._isSpeaking;
    }
    async closeSession() {
        try {
            if (this.avatar && this.sessionId) {
                await this.avatar.stopAvatar();
                console.log('🔒 Session closed:', this.sessionId);
                this.sessionId = null;
            }
            this.videoElement.srcObject = null;
        }
        catch (err) {
            console.error('Error closing session:', err);
        }
    }
    async interruptSpeaking() {
        this._isSpeaking = false;
        if (this.avatar) {
            await new Promise((resolve) => setTimeout(resolve, 500));
            await this.avatar.interrupt();
        }
    }
    async destroy() {
        console.log('[AvatarManager] Destroying...');
        await this.closeSession();
        if (this.avatar) {
            this.removeAllListeners?.(); // Safely remove listeners if method exists
            this.avatar = null;
        }
        this.removeAllListeners(); // From EventEmitter
        this.token = null;
        this.avatarConfig = null;
        this.sessionId = null;
        this.avatarLoading = true;
        this.videoElement.srcObject = null;
        console.log('[AvatarManager] Destroyed');
    }
}
